import { html, render } from "../../"
import { isTouch } from "../../global/globals"
import { SYSBaseElement } from "../sysbaseelement"
import { SnackAdd } from "../snackapi"
import { createDynamicRowFunctions, rowControlActionsHandler } from "./helpers"
import type { OvlSysColumn, SYSTableData, SYSTableDef } from "./table"
import { _RenderTracking } from "../../tracker/tracker"

export type NavProps = {
  tableDef: SYSTableDef
  data: SYSTableData
  key: string
}

export type RowControlAllAction = {
  name: string
  icon: string
  disabled: boolean
  custom: boolean
}

export class SYSTableRowControl extends SYSBaseElement {
  props: any
  nav: NavProps

  async init() {
    this.nav = this.props()
    await super.init()
  }

  async getUI() {
    let key = this.nav.key
    let def = this.nav.tableDef
    let row = this.nav.data.data

    if (
      !row[key] ||
      (row[key].OvlSysState as OvlSysColumn).rowState.state === "Add"
    ) {
      return null
    }
    // put together a dynamic list of actions
    // consisting of "default" deit/copy/delete ones and the ones from state custom
    let comp = _RenderTracking.currentComponent
    let rowControlActions = await createDynamicRowFunctions(
      def,
      this.nav.data,
      key,
      false
    )
    let rowControlButtons
    _RenderTracking.currentComponent = comp
    let rowActions = Object.keys(rowControlActions).filter(
      (f) => rowControlActions[f].visibility !== "NotVisible"
    )
    let rowActionsCount = rowActions.length

    rowControlButtons = rowActions.map((k, i) => {
      let button = rowControlActions[k]
      let border = "ovl-middlebutton"
      if (i === 0) {
        border = "ovl-firstbutton"
      } else if (i === rowActionsCount - 1) {
        border = "ovl-lastbutton"
      }
      let buttonDisabled = button.visibility === "Disabled"

      return html`
        <button
          .data=${{
            functionKey: k,
            rowKey: this.nav.key,
          }}
          ?disabled=${buttonDisabled}
          id=${`OvlRowFn${k}${this.nav.key}`}
          title=${button.tooltip}
          class=${`fd-button ${border} ${
            button.customClass ? button.customClass : ""
          } ovl-rowfn-${k}`}
        >
          <i class=${button.icon}></i>
        </button>
      `
    })

    if (rowControlButtons.length === 0) {
      return null
    }
    return html`
      <td
        class="fd-table__cell"
        colspan="${this.nav.tableDef.uiState.columnsRenderingState
          .visibleInTable.length}"
      >
        <div class="ovl-rowcontrol-wrapper">
          <div
            class="ovl-rowcontrol fd-segmented-button animated fadeIn faster"
            role="group"
            aria-label="Rowcontrol"
          >
            ${rowControlButtons}
          </div>
        </div>
      </td>
    `
  }
}
